var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMnumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.75C3.75 4.27513 3.75 3.03769 4.51885 2.26885C5.28769 1.5 6.52513 1.5 9 1.5C11.4748 1.5 12.7123 1.5 13.4812 2.26885C14.25 3.03769 14.25 4.27513 14.25 6.75V11.25C14.25 13.7248 14.25 14.9623 13.4812 15.7312C12.7123 16.5 11.4748 16.5 9 16.5C6.52513 16.5 5.28769 16.5 4.51885 15.7312C3.75 14.9623 3.75 13.7248 3.75 11.25V6.75Z",
    stroke: "#626F86",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 14.25H9.75",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 1.5L6.81675 1.90051C6.96141 2.76847 7.03374 3.20245 7.33139 3.46653C7.6419 3.742 8.08208 3.75 9 3.75C9.91792 3.75 10.3581 3.742 10.6686 3.46653C10.9663 3.20245 11.0386 2.76847 11.1833 1.90051L11.25 1.5",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMnumber);
export default __webpack_public_path__ + "static/media/mnumber.353335f35f59273690d74a727ef04cd2.svg";
export { ForwardRef as ReactComponent };